// A multi-select dropdown with a checkbox in front of every value (as in
// dAdmin's Holiday screen): the menu stays open while ticking, and ticked
// values stay in the list (highlighted) so they can be unticked there.

import React from "react";
import Select, { components } from "react-select";
import "./CheckboxSelect.css";

function CheckboxOption(props) {
    const { isSelected, label, data } = props;
    return (
        <components.Option {...props}>
            <span className="cbs-option">
                <input type="checkbox" checked={isSelected} readOnly tabIndex={-1} aria-hidden="true" />
                <span>
                    <span className="cbs-option-label">{label}</span>
                    {data.detail && <span className="cbs-option-detail">{data.detail}</span>}
                </span>
            </span>
        </components.Option>
    );
}

export default function CheckboxSelect({ components: extra, classNamePrefix = "cbs", ...props }) {
    return (
        <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{ Option: CheckboxOption, ...extra }}
            classNamePrefix={classNamePrefix}
            {...props}
        />
    );
}
